"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalStorageClient = void 0;
var _nodeFs = require("node:fs");
var _promises = require("node:fs/promises");
var _promises2 = require("node:stream/promises");
class LocalStorageClient {
  deleteFile(path) {
    return (0, _promises.unlink)(path);
  }
  async exists(path) {
    try {
      await (0, _promises.access)(path, _promises.constants.F_OK);
      return true;
    } catch {
      return false;
    }
  }
  readFile(path) {
    return Promise.resolve((0, _nodeFs.createReadStream)(path));
  }
  writeFile(path, content) {
    return (0, _promises2.pipeline)(content, (0, _nodeFs.createWriteStream)(path));
  }
}
exports.LocalStorageClient = LocalStorageClient;